import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import type { DeviceIdType, DeviceType } from "../device/device";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, input } from "../van/van-tags";

export class AdminPage implements Route {
	#deviceField(deviceIdType: DeviceIdType, deviceType: DeviceType): ChildDom {
		return div(
			{
				class: "field has-addons",
			},
			div(
				{
					class: "control is-expanded",
				},
				input({
					class: "input",
					oninput: (e: Event) => {
						if (!(e.target instanceof HTMLInputElement)) return;
						this.#id = e.target.value;
					},
					placeholder: deviceIdType,
				}),
			),
			div(
				{
					class: "control",
				},
				button(
					{
						class: "button is-primary",
						onclick: () => {
							this.#ctx.router.jump(
								`/admin/${deviceType.toLowerCase().replaceAll(" ", "-")}/${this.#id}`,
							);
						},
					},
					deviceType,
				),
			),
		);
	}

	/**
	 * @param {import("navigo").Match} _
	 */
	async refresh(_: Match): Promise<void> {}

	#ctx: RouteContext;
	#id = "";
	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{
				size: "narrow",
			},
			h1(
				{
					class: "title is-4",
				},
				"Admin",
			),
			div(
				{
					class: "buttons",
				},
				button(
					{
						class: "button is-fullwidth is-primary",
						onclick: () => this.#ctx.router.jump("/admin/user"),
					},
					"User",
				),
				button(
					{
						class: "button is-fullwidth is-primary",
						onclick: () => this.#ctx.router.jump("/admin/notices"),
					},
					"Notices",
				),
			),
			this.#deviceField("IMSI", "FarmCam SIM"),
			this.#deviceField("IMEI", "FenceAlarm"),
			this.#deviceField("IMEI", "FenceAlarm2"),
			this.#deviceField("IMEI", "SmartPlug"),
			this.#deviceField("IMEI", "SmartPlug2"),
		);
	}
}
